export default __webpack_public_path__ + "static/logo-wall-7a60f048a6eb613ea667f2d304e6faab.png";